module.exports = __webpack_public_path__ + "img/mapSettings.81d9498.png";